import { FileSharingAccountDTO } from "../DTO/fileSharingAccountDTO";
import { BasicRequest } from "./basicRequest";

export class DeleteFileSharingAccountRequest extends BasicRequest{
    public fileSharingAccount!: FileSharingAccountDTO;

    constructor(){
        super();
    }
}